import { useState, useEffect } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import BloomLogo from "../assets/Bloomlogo.svg";

export default function Login() {
  const [passphrase, setPassphrase] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const CORRECT_PASSPHRASE = "BloomVoice2007";

  const handleLogin = () => {
    if (passphrase === CORRECT_PASSPHRASE) {
      setError("");
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('authTimestamp', Date.now().toString());
      navigate("/home");
    } else {
      setError("Invalid passphrase. Please try again.");
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  useEffect(() => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('authTimestamp');
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="absolute top-4 left-6">
        <p className="text-2xl font-bold ml-12 text-gray-800">Galileo Voice Platform</p>
      </div>
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        <h1 className="text-2xl font-semibold text-gray-900 text-center mb-8">
          Welcome to Galileo
        </h1>
        
        <div className="relative mb-6">
          <input
            type={showPassword ? "text" : "password"}
            value={passphrase}
            onChange={(e) => setPassphrase(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Passphrase"
            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button 
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
            onClick={() => setShowPassword(!showPassword)}
            type="button"
          >
            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
          </button>
        </div>

        {error && (
          <p className="text-red-500 text-sm mb-4 text-center">
            {error}
          </p>
        )}

        <button 
          className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium py-3 rounded-lg transition-colors"
          onClick={handleLogin}
        >
          Login
        </button>
      </div>
    </div>
  );
}
